{
  "V": "N",
  "constraints": [
    {
      "axis": "G1",
      "op": "<=",
      "value": 5
    },
    {
      "axis": "G2",
      "op": "<=",
      "value": 5
    },
    {
      "axis": "G3",
      "op": "<=",
      "value": 5
    },
    {
      "axis": "G4",
      "op": "<=",
      "value": 5
    }
  ],
  "notes": "Regime 3 bounded cone in count space (demo). Real systems use V-enriched weights.",
  "region_id": "REGION_R3_BOUNDED"
}
